import styled from 'styled-components';

export const BadgeBox = styled.span`
  width: 25px; 
  height: 16px; 
  background-color: #C02A34; 
  padding: 4px; 
  border-radius: 4px; 
  color: #FFFFFF; 
  font-size: 12px; 
  margin-left: 5px;
`;